module.exports = __webpack_public_path__ + "static/adjustable-base-fluted-0a50a8bbaa76014bca88df27b51ed119.jpeg";